<div style="padding:16px 0;">
    <div class="container-full">
        <div class="row g-0">
            <div class="col-2">
                <button class="btn btn-primary mt-3 ace-blue" style="width:200px;position: relative;top:-10px;" (click)="onConfirmProceedGeneratingPrelimInvoices()" [disabled]="disablePrelimGeneration || isProcessing">
                                        Generate Prelims
                </button>
            </div>
            <div class="col-10">
                    @if(isInvoiceLineDescriptionCustomizationEnabled){
                        <mat-form-field appearance="outline" style="margin-left:0px; width:100%;">
                                    <mat-label>Invoice Line Description</mat-label>
                                    <input
                                        matInput
                                        [value]="invoiceLineDescription"
                                        maxlength="250"
                                        (input)="invoiceLineDescription = $any($event.target).value"
                                        style="width:95%;"
                                    />
                        </mat-form-field>
                    }
            </div>
            
        </div>

        @if(isProcessing) {
            <div class="row g-0 mt-2">
                <div class="col-12">
                    <div class="alert alert-info">
                        <strong>Processing:</strong> {{ jobStatusMessage }}
                        @if(jobProgressPercentage > 0) {
                            <span> - {{ jobProgressPercentage }}%</span>
                        }
                    </div>
                </div>
            </div>
        }

        <div class="row g-0">
            <div class="col-2">
                <span>Revenue Date:</span>
            </div>
            <div class="col-10">
                 <strong>{{ revenueDate | date:'M-d-yyyy' }}</strong>
            </div>
            <div class="col-2">
                <span>Due Date:</span>
            </div>
            <div class="col-10">
                 <strong>{{ dueDate | date:'M-d-yyyy' }}</strong>
            </div>
        </div>
    </div>
</div>
